import React from 'react';
import { MenuItem, TextField } from '@mui/material';

export function BookSearchField({ type, sx, handleSearch, }) {
  const [typingTimeout, setTypingTimeout] = React.useState(0);

  const handleType = e => {
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }
    setTypingTimeout(
      setTimeout(() => {
        handleSearch(e.target.value);
      }, 1500)
    );
  };
  return (
    <>
    <TextField
      fullWidth
      placeholder='Search'
      onChange={handleType}
      type={type && type}
      sx={sx && sx}
    />
  </>
  );
}
